export const BOX_WRAPPER_STYLES = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  margin: '32px 0px',
  width: '100%',
};
